import { Controller } from "@hotwired/stimulus"

// 重要操作の実行前に確認文字列の入力を求めるモーダルを制御するコントローラ。
// 確認文字列が一致するまで実行ボタンを無効化する。これにより誤操作を防ぎつつ、実行時には同条件で削除が行われる（件数は変動する可能性あり）。
// 最終確認（サーバー側検証）も併せて行う。openValue が true の場合、サーバー描画直後に自動でモーダルを開く。
export default class extends Controller {
  static targets = ["dialog", "input", "submit"]
  static values = {
    word: { type: String, default: "reset" },
    open: { type: Boolean, default: false }
  }

  connect() {
    if (this.openValue) this.open()
  }

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    if (this.hasInputTarget) this.inputTarget.value = ""
    this.validate()
    this.dialogTarget.close()
  }

  // 対象0件の案内モーダルなど、入力欄を持たない用途でも呼べるようガードする。
  validate() {
    if (!this.hasInputTarget || !this.hasSubmitTarget) return

    this.submitTarget.disabled = this.inputTarget.value !== this.wordValue
  }
}
